import React from 'react';
import SlideLayout, { SlideTitle, SlideContent } from '../components/SlideLayout';
import { ArrowRight, Zap, Star } from 'lucide-react';

const stages = [
  { name: 'Pre-training', desc: 'Next Token Prediction', data: 'Billions of tokens', color: 'muted' },
  { name: 'Instruction Tuning', desc: 'Follow Instructions', data: '10K-100K pairs', color: 'primary' },
  { name: 'RLHF', desc: 'Human Alignment', data: '10K-50K preferences', color: 'secondary' },
  { name: 'RLVR', desc: 'Reasoning Emergence', data: 'Millions (auto)', color: 'accent' },
];

const TrainingPipelineSlide = () => {
  return (
    <SlideLayout maxWidth="6xl">
      <SlideTitle 
        subtitle="The evolution from base models to reasoning capabilities"
      >
        Training Pipeline Evolution
      </SlideTitle>
      
      <SlideContent>
        {/* Pipeline visualization */}
        <div className="flex flex-wrap items-center justify-center gap-2 md:gap-4 mb-10">
          {stages.map((stage, index) => (
            <React.Fragment key={index}>
              <div className={`slide-card text-center px-4 md:px-6 py-4 border-${stage.color}/30`}>
                <div className="font-heading font-semibold text-sm md:text-base text-foreground">{stage.name}</div>
                <div className="text-xs text-muted-foreground mt-1">{stage.desc}</div>
              </div>
              {index < stages.length - 1 && (
                <ArrowRight className="w-5 h-5 text-muted-foreground flex-shrink-0" />
              )}
            </React.Fragment>
          ))}
        </div>
        
        {/* Comparison table */}
        <div className="slide-card overflow-hidden">
          <table className="comparison-table">
            <thead>
              <tr>
                <th>Method</th>
                <th>Data Type</th>
                <th>Scale</th>
                <th>Output</th>
              </tr>
            </thead>
            <tbody>
              {[
                ['Pre-training', 'Raw text', 'Billions of tokens', 'Base model'],
                ['SFT', 'Instruction pairs', '10K-100K', 'Assistant'],
                ['RLHF', 'Human preferences', '10K-50K', 'Aligned model'],
                ['RLVR', 'Verifiable problems', 'Millions', 'Reasoning model'],
              ].map((row, index) => (
                <tr key={index}>
                  {row.map((cell, cellIndex) => (
                    <td key={cellIndex} className={cellIndex === 0 ? 'font-medium text-foreground' : 'text-muted-foreground'}>
                      {cell}
                    </td>
                  ))}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        
        {/* 2025 Breakthrough */}
        <div className="mt-8 p-6 rounded-xl bg-accent/10 border border-accent/30">
          <div className="flex items-start gap-4">
            <div className="p-2 rounded-lg bg-accent/20">
              <Star className="w-5 h-5 text-accent" />
            </div>
            <div>
              <p className="font-heading font-semibold text-foreground">2025 Breakthrough</p>
              <p className="text-sm text-muted-foreground mt-1">
                <strong className="text-accent">DeepSeek R1</strong> demonstrated that reasoning emerges from RL on verifiable tasks, 
                <span className="text-foreground"> NOT just from scaling model size.</span>
              </p>
            </div>
          </div>
        </div>
      </SlideContent>
    </SlideLayout>
  );
};

export default TrainingPipelineSlide;
